import { render } from "./FileViewerWithVersions.vue?vue&type=template&id=e7068e7a&scoped=true"
import script from "./FileViewerWithVersions.vue?vue&type=script&lang=js"
export * from "./FileViewerWithVersions.vue?vue&type=script&lang=js"

import "./FileViewerWithVersions.vue?vue&type=style&index=0&id=e7068e7a&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7068e7a"]])

export default __exports__